import Vue from 'vue'
import VueGtag from 'vue-gtag'
import router from '@/router'

if (process.env.NODE_ENV === 'production') {
  Vue.use(
    VueGtag,
    {
      appName: 'Minimart Storefronts',
      config: {
        id: 'G-CWRSB1N89Q',
        params: {
          send_page_view: false,
        },
      },
      pageTrackerScreenviewEnabled: true,
    },
    router
  )
}
